import { type SetStateAction } from 'react';
import type { ConsoleEntry, ConsoleTableColumn } from '../../command_center/components/center/modals/console/types/consoleTypes';
import {
  TcTmCombinedGreenIcon,
  TcIconGreen,
  TmIconGreen,
} from '../../command_center/components/center/modals/Svgs';
import {
  BeaconSvg,
  HealthMetricSvg,
  InvalidTmSvg,
} from '../../command_center/components/center/modals/console/ConsoleSvg';
import { get_formated_time } from '../../command_center/utils';

// ─── Layout heights ────────────────────────────────────────────────────────────

export const SECTION_HEADER_HEIGHT = 28;
export const ROW_HEIGHT = 28;
export const SECTION_BORDER_HEIGHT = 1;
export const SECTION_GAP = 4;
export const BOTTOM_LOAD_THRESHOLD = 24;
export const SUBSYSTEM_HEADER_VISIBLE = 3;

// ─── No-op stubs (used for read-only message-tab item data) ───────────────────

export const noopSetEntries = (_value: SetStateAction<ConsoleEntry[]>) => undefined;
export const noopSetTestPlanResults = (_value: SetStateAction<Record<string, boolean | string>>) => undefined;
export const noopGetCommandDetails = (_entry: ConsoleEntry) => undefined;
export const noopSetNumberState = (_value: SetStateAction<number>) => undefined;

// ─── Column definitions for the messages tab ─────────────────────────────────

export const REPORTS_MESSAGE_COLUMNS: ConsoleTableColumn[] = [
  {
    label: 'TcTmType',
    value: (entry) => entry?.CommandDetails?.tctmType as string | undefined,
    isSelected: true,
    width: '52',
    isSvg: true,
    svg: <TcTmCombinedGreenIcon />,
    isFilterAvailable: false,
    renderIcon: (entry) => {
      const type = entry?.CommandDetails?.tctmType;
      switch (type) {
        case 'Health Metric': return <HealthMetricSvg color="#7AB3FF" />;
        case 'Beacon':        return <BeaconSvg color="#7AB3FF" />;
        case 'Invalid TM':    return <InvalidTmSvg color="#C91818" />;
        case 'TM':
        case 'tm':            return <TmIconGreen />;
        case 'TC':
        case 'tc':            return <TcIconGreen />;
        case 'TCTM':          return <TcTmCombinedGreenIcon />;
        default:              return null;
      }
    },
    dashboard: 'summary',
  },
  {
    label: 'Time',
    value: (entry) => (
      typeof entry?.CommandDetails?.timestamp === 'number'
        ? get_formated_time(entry.CommandDetails.timestamp)
        : '--'
    ),
    isSelected: true,
    width: '255',
    isFilterAvailable: false,
    dashboard: 'summary',
  },
  {
    label: 'TC/TM ID',
    value: (entry) => entry?.CommandDetails?.tctmId as string | number | undefined,
    isSelected: true,
    width: '116',
    isFilterAvailable: false,
    dashboard: 'summary',
  },
  {
    label: 'Source',
    value: (entry) => entry?.CommandDetails?.saId as string | number | undefined,
    isSelected: true,
    width: 'flex',
    isFilterAvailable: false,
    dashboard: 'summary',
  },
  {
    label: 'Destination',
    value: (entry) => entry?.CommandDetails?.daId as string | number | undefined,
    isSelected: true,
    width: 'flex',
    isFilterAvailable: false,
    dashboard: 'summary',
  },
  {
    label: 'Bytes Length',
    value: () => '',
    isSelected: true,
    width: '180',
    isFilterAvailable: false,
    dashboard: 'summary',
  },
];
